<template>
  <time>
    <div class="time">{{time}}</div>
    <div class="date">{{date}}</div>
  </time>
</template>

<script>
  import moment from 'moment'
  export default {
    name: "Time",
    components: {},
    props: {},
    data() {
      return {
        date: moment().format("ddd, MMM DD"),
        time: moment().format("HH:mm")
      }
    },
    mounted() {
      this.timer = setInterval(() => {
        this.time = moment().format("HH:mm");
      }, 1000);
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  }

</script>
<style lang="scss" scoped>
  time {
    width: 90px;
    display: flex;
    flex-flow: column;
    align-items: flex-end;
    justify-content: center;
    // color: #fff;
  }

  .time {
    font-size: 23px;
    text-align: right;
  }

  .date {
    // width:77px;
    font-size: 10px;
    text-align: left;
  }

</style>
